import { connect } from "react-redux";

import ListRecipe from "./ListRecipe";

const mapStatetoProps = state => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(ListRecipe);
